"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLayers(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M17.875 11L20 12.049 12 16l-8-3.951L6.123 11 12 13.903zm0-4L20 8.048 12 12 4 8.048 6.123 7 12 9.902zM12 0l8 4-8 4-8-4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Layers')(SvgLayers);
//# sourceMappingURL=Layers.js.map